//------------------------
// get race details by id
//------------------------
export default function getRaceDetailsById(raceid, objArray) {
  let details = objArray.find((a) => a.id == raceid);
  return details;
}
